import {
  JsonRpcApiProvider,
  JsonRpcApiProviderOptions,
  JsonRpcError,
  JsonRpcPayload,
  JsonRpcResult,
  Networkish,
} from "ethers";

export class ConnectRpcProvider extends JsonRpcApiProvider {
  readonly #provider: JsonRpcApiProvider;

  constructor(
    private readonly connectionSend: (
      payload: JsonRpcPayload | JsonRpcPayload[],
    ) => Promise<JsonRpcResult[]>,
    provider: JsonRpcApiProvider,
    network?: Networkish,
    options?: JsonRpcApiProviderOptions,
  ) {
    super(network, options);
    this.#provider = provider;
  }

  async _send(
    payload: JsonRpcPayload | Array<JsonRpcPayload>,
  ): Promise<Array<JsonRpcResult | JsonRpcError>> {
    if (!Array.isArray(payload)) {
      payload = [payload];
    }

    const transactions: JsonRpcPayload[] = [];
    const other: JsonRpcPayload[] = [];

    payload.forEach((p) => {
      if (p.method === "eth_sendTransaction") {
        transactions.push(p);
      } else {
        other.push(p);
      }
    });

    return await Promise.all([
      ...(await (transactions.length > 0
        ? this.connectionSend(transactions)
        : [])),
      ...(await (other.length > 0 ? this.#provider._send(other) : [])),
    ]);
  }
}
